import React, { Component } from 'react';

import '../../helpers/Array'
import Content from '../../components/Content'
import Item from '../../components/Item'
import Icon from '../../components/Icon'

import moment from 'moment';

class Twitter extends Component {

	constructor(props) {
    super(props);
    
  }
  
  processTweetLinks = (text) => {
    var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;
    text = text.replace(exp, "<a href='$1' target='_blank'>$1</a>");
    exp = /(^|\s)#(\w+)/g;
    text = text.replace(exp, "$1<a href='http://search.twitter.com/search?q=%23$2' target='_blank'>#$2</a>");
    exp = /(^|\s)@(\w+)/g;
    text = text.replace(exp, "$1<a href='http://www.twitter.com/$2' target='_blank'>@$2</a>");
    return text;
}
  
  render() {

  
  	if(!this.props.items) return null;

    return (
      <div>
 		{ this.props.items.limit(1).map((item) => 

 			(
 				<Item modifiers={['tweet']}>
 					<div className="Item-head">
 						{ moment(item.created_at, 'dd MMM DD HH:mm:ss ZZ YYYY', 'en').format('MMMM Do') }
 					</div>
 					<div className="Item-body">
 					
 						<p dangerouslySetInnerHTML={{__html: this.processTweetLinks(item.text) }} />
 				
 					</div>
 					<div className="Item-foot">
 						<a target="_blank" href="https://twitter.com/TheFenway">
 						thefenway<br />
 						<Icon type="twitter-yellow" />
 						</a>
 					</div>
 				</Item>
 			)

 		) }
      </div>
    );
  }
}

export default Twitter;



// WEBPACK FOOTER //
// ./src/js/components/Twitter/Twitter.js